import { useContext } from "react";

import { AgendaItemTypesContext } from "./AgendaItemTypesContext";

export function useAgendaItemTypes() {
  const context = useContext(AgendaItemTypesContext);
  if (!context) {
    throw new Error("useAgendaItemTypes must be used within a AgendaItemTypesProvider");
  }
  return context;
}
